import Vue from 'vue'
import App from './App'
import routes from './router'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import store from './store'
import { commonPoint, pathBack, pathBackNew } from '@/utils/request'
Vue.use(ElementUI);
Vue.use(VueRouter)

import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/font-awesome.css'
import './assets/css/common.css'


Vue.prototype.commonPoint = commonPoint
Vue.prototype.pathBack = pathBack
Vue.prototype.pathBackNew = pathBackNew
if (process.env.NODE_ENV == "production") {
    // 生产环境
    Vue.prototype.$baseURL = 'https://bdprod.huashouren.com' //内部服务器
    Vue.prototype.$siteURL = 'https://bdh5.huashouren.com' //外部api
    Vue.prototype.$mianURL = 'https://advert.huashouren.com' //支付主体
    Vue.prototype.$backend = 'https://api.huashouren.com' //中后台api
    // Vue.prototype.$single = 'https://hsryd-api.huashouren.com' //php版本域名
    Vue.prototype.$single = 'https://api-hsr.huashouren.com' //php版本域名
} else {
    // Vue.prototype.$baseURL = 'https://bdstag.huashouren.com' //原灰度服务器
    Vue.prototype.$baseURL = 'https://bdtest.huashouren.com' //内部服务器
    Vue.prototype.$mianURL = 'https://adverttest.huashouren.com' //支付主体
    Vue.prototype.$siteURL = 'https://bdtesth5.huashouren.com' //外部api
    Vue.prototype.$backend = 'https://test-api.huashouren.com' //中后台api
    Vue.prototype.$single = 'https://api-test.huashouren.com' //php版本域名
}

// 关联小程序-华寿小助手
// Vue.prototype.$wechatAppid = 'wxd2c6a9fd2584ff1a'
// Vue.prototype.$wechatSecret = 'c23d9857f25b3ac41e2753fcc29fd568'

// 关联小程序-华寿分班-测试专用
Vue.prototype.$wechatAppid = 'wx211ee792e7aaaa41'
Vue.prototype.$wechatSecret = 'e6441893f407eee5b2dd3816f8a7cee3'

const router = new VueRouter({
    mode: 'history',
    routes: routes
})

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js